import { memo } from 'react'
import { Trend } from '../Widgets/types'
import OuterWidget from '@/components/Common/OuterWidget/OuterWidget'

const TREND_DISPLAY = {
  BULLISH: 'Bullish',
  NEUTRAL: 'Neutral',
  BEARISH: 'Bearish',
}

const OverallSummaryTable = ({ trends }: { trends: Trend[] }) => {
  if (!trends.length) return null
  return (
    <OuterWidget title="Overall">
      {trends.map(({ count, trend }) => (
        <div
          key={trend}
          className="border-b-1 flex flex-row justify-between py-3 text-sm"
        >
          <span>{TREND_DISPLAY[trend]}</span>
          <span>{count}</span>
        </div>
      ))}
    </OuterWidget>
  )
}

OverallSummaryTable.displayName = 'SummaryTable'

export default memo(OverallSummaryTable)
